import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { MailWarning, X } from "lucide-react";

export const VerifyBanner = () => {
  const { user, resendVerification } = useAuth();
  const [sent, setSent] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    try { await resendVerification(); } catch { /* shown as sent regardless */ }
    setSent(true);
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200" data-testid="verify-banner">
      <div className="max-w-7xl mx-auto px-5 py-2.5 flex items-center gap-3 text-sm text-amber-800 flex-wrap">
        <MailWarning className="w-4 h-4 shrink-0" />
        <span className="flex-1 min-w-0">Please verify your email address to keep your account secure. Check your junk / spam folder if the email hasn't arrived.</span>
        {!sent ? (
          <button data-testid="verify-resend" onClick={resend} className="font-semibold underline hover:text-amber-900">Resend verification email</button>
        ) : (
          <span className="font-semibold" data-testid="verify-sent">Verification email sent — please check your inbox, and your junk / spam folder if you don't see it.</span>
        )}
        <button onClick={() => setDismissed(true)} className="text-amber-500 hover:text-amber-700"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
